import httpClient from "../http/http-client";
import { IFinishedProduct, IFinishedProductFull } from './finished-product.model';

export default class FinishedProductService {
  http;

  constructor() {
    this.http = httpClient
  }

  async create(details: IFinishedProduct): Promise<IFinishedProduct> {
    return this.http.post(`finished-product/create`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAll(): Promise<IFinishedProduct[]> {
    return this.http.get(`finished-product`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOne(productId: string): Promise<IFinishedProductFull> {
    return this.http.get(`finished-product/${productId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async addProductComponent(productId: string, productComponentId: string, quantityPerProduct: number): Promise<IFinishedProductFull> {
    return this.http.post(`finished-product/${productId}/add-product-component`, { productComponentId: productComponentId, quantityPerProduct: quantityPerProduct })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async removeProductComponent(productId: string, productComponentId: string): Promise<IFinishedProductFull> {
    return this.http.post(`finished-product/${productId}/remove-product-component`, { productComponentId: productComponentId })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async update(productComponentId: string, details: IFinishedProduct): Promise<IFinishedProduct> {
    return this.http.patch(`finished-product/${productComponentId}`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}